import angular from 'angular'
import canonicalUrlComponent from './canonicalUrl.component'

// TODO: this is not a proper component because the controller works on the
// story object - refactor that out to a pub/sub point on the service
//

export default angular
  .module('ellipsis.canonicalUrl', [])
  .component('canonicalUrl', canonicalUrlComponent)
